import axios from 'axios';
import type { BannerResponse, Banner } from '../types/banner';
import { logger } from '../utils/logger';

const BASE_URL = import.meta.env.VITE_API_BASE_URL;
const BANNER_ENDPOINT = import.meta.env.VITE_API_V1_ADS_BANNER;

export const getBanners = async (): Promise<Banner[]> => {
  try {
    const response = await axios.get<BannerResponse>(`${BASE_URL}${BANNER_ENDPOINT}`);
    return response.data.ads;
  } catch (error) {
    logger.error('Error fetching banners:', error);
    return [];
  }
};
